<div class="relative w-10 select-container" #selectContainer>

  <div class="flex items-center justify-end w-full cursor-pointer" (click)="toggleDropdown()">
    <i class="text-text-primary text-[16px] flex items-center justify-center" [ngClass]="icon"></i>
  </div>
</div>

<div #dropdownEl *ngIf="isOpen()"
  class="fixed z-[9999] bg-white rounded-2xl animate-fadeIn flex flex-col border border-soft-gray-outline"
  [style.top]="dropdownStyles['top']" [style.left]="dropdownStyles['left']"
  [style.max-height]="dropdownStyles['maxHeight']" [style.width]="dropdownStyles['width']"
  style="box-shadow: 0px 8px 16px rgba(0,0,0,0.16);">
  <div class="flex items-center w-full my-2 px-2 flex-shrink-0">
    <i
      class="fi fi-rr-search absolute left-6 text-text-secondary leading-none pt-[1px] text-xl flex items-center justify-center"></i>
    <input type="text"
      class="w-full pl-12 pr-10 py-3 h-[40px] rounded-2xl border leading-none text-sm font-poppins font-medium border-soft-gray focus:outline-none placeholder:text-text-primary placeholder:font-normal"
      [placeholder]="placeholder" [(ngModel)]="searchTerm" (click)="$event.stopPropagation()" />
    <i (click)="clearSearch(); $event.stopPropagation()"
      class="fi fi-rr-x absolute cursor-pointer right-6 text-text-primary text-xs leading-none pt-[1px] flex items-center justify-center"></i>
  </div>
  <ul class="overflow-auto flex-1 px-2 pb-2">
    <li *ngFor="let option of filteredOptions; let i = index"
      class="px-4 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-50 rounded-lg"
      (click)="toggleOption(option, $event)">
      <div class="flex items-center gap-2">
        <app-checkbox [id]="'checkbox-' + option.value + '-' + i" [checked]="option.active"></app-checkbox>
        <p class="text-text-primary font-poppins font-normal text-sm flex-1">
          {{ option.label }}
        </p>
      </div>
    </li>

    <li *ngIf="filteredOptions.length === 0"
      class="px-4 py-2 text-text-primary font-poppins font-normal text-sm text-center">
      No hay resultados
    </li>
  </ul>
</div>